// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__3Gjbu","large":"styles_large__1B4ua"};